import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { language } from '../actions/CommonAction';
const NavigationInfo = [{
	chinese: '首页',
	english: 'HOME',
	url: '/'
}, {
	chinese: '产品',
	english: 'PRODUCT',
	url: '/product/1',
	son: [
		{
			chinese: '美国专线',
			english: 'US Logistics Service',
			url: '/product/1',
		},
		{
			chinese: '英国专线',
			english: 'UK Logistics Service',
			url: '/product/2',
		},
		{
			chinese: '德国及欧盟专线',
			english: 'DE & EU Logistics Service',
			url: '/product/3',
		},
		{
			chinese: '邮政小包服务',
			english: 'Economic Parcel Service',
			url: '/product/4',
		},
		{
			chinese: 'PMS空海运大货',
			english: 'PMS Air and Sea Cargo',
			url: '/product/5',
		}
	]
}, {
	chinese: '关于',
	english: 'ABOUT',
	url: '/about/index',
	son: [{
		chinese: '公司介绍',
		english: '',
		url: '/about/index',
	}, {
		chinese: '价格查询',
		english: '',
		url: '/about/price',
	}]
}, {
	chinese: '联系',
	english: 'CONTACT',
	url: '/contact'
}];
const navAddress = [
	// {
	// 	chinese: '广州办公地址：广州市天河区潭村路348号604房',
	// 	english: 'Guangzhou Office Address: Room 604,No.348 Tancun Road, Tianhe district,Guangzhou City',
	// },
	{
		chinese: '佛山办公地址：佛山市南海区海五路28号富力国际金融中心A区2栋9层',
		english: 'Foshan Office Address: Floor 9,Block 2,Area A ,28 Haiwu Road, Fuli International Financial Center,Nanhai District,Foshan'
	}
];
const LoginView = {
	chinese: '登录',
	english: 'LOGIN',
}
@connect()
export default class Navigation extends React.Component {
	state = {
		url: '/'
	};
	constructor(props) {
		super(props);
		this.changeLanguage = this.changeLanguage.bind(this);
		this._setNavUrl = this._setNavUrl.bind(this);
	}
	_setNavUrl(e, url) {
		e.stopPropagation();
		this.setState({
			url: url
		})
	}

	componentDidMount() {
		try {
			this.setState({
				url: window.location.pathname
			})
		} catch (e) {

		}

		for (let item in this.refs.selectLaugage.options) {
			try {
				if (this.refs.selectLaugage.options[item].value == this.props.language) {
					this.refs.selectLaugage.options[item].selected = true;
				}
			} catch (e) { }

		}
	}
	navList() {
		const { language } = this.props;
		return (
			<ul>
				{NavigationInfo.map((list, key) =>
					<li
						key={key.toString()}
						onClick={(e) => this._setNavUrl(e, list.url)}
						onMouseOver={(e) => this.navMouseover(e, list, key)}
						onMouseOut={(e) => this.navMouseout(e, list, key)}>
						<Link to={list.url}
							className={this.state.url == list.url ? 'active' : ''}>{list[language]}</Link>
						{this.subNavList(list)}
					</li>
				)}
			</ul>
		)

	}
	subNavList(data) {
		const { language } = this.props;
		if (!!data.son && typeof data.son === 'object') {
			return (
				<div className="pms-nav-subnav">
					<ul>
						{
							data.son.map((value, key) =>
								<li key={key.toString()} onClick={(e) => this._setNavUrl(e, value.url)}>
									<Link to={value.url} className={this.state.url == value.url ? 'nav-subnav-active' : ''}>{value[language]}</Link></li>
							)
						}
					</ul>
				</div>
			)
		} else {
			return '';
		}
	}
	navMouseover(e, data, i) {
		if (!!data.son && typeof data.son === 'object') {
			let target = document.querySelector('.pms-nav-list-container ul').children[i]
			target.classList.add('active');
		}
	}
	navMouseout(e, data, i) {
		let target = document.querySelector('.pms-nav-list-container ul').children[i]
		target.classList.remove('active');
	}
	changeLanguage(e) {
		let languageValue = 'chinese';
		try {
			languageValue = e.target.options[e.target.selectedIndex].value
		} catch (e) { }
		this.props.dispatch(language(languageValue))
		window.localStorage.setItem('language', languageValue);
	}
	render() {
		const { language } = this.props;
		return (
			<div className="pms-navigation">
				<div className="pms--nav-header-address">
					<div className="center clear">
						<div className="col-xs-2">
							<i className="footer-icon"><img src={require('../assets/image/email.png')} alt="" /></i>
							pms01@pms.com.cn</div>
						<ul className="col-xs-10 ellipsis">
							{
								navAddress.map((addr, index) =>
									<li key={index}><i className="footer-icon"><img src={require('../assets/image/address.png')} alt="" /></i>
										{addr[language]}</li>)
							}
						</ul>
					</div>

				</div>
				<div className="pms-navigation-container">
					<div className="pms-logo">
						<Link to="/">
							<img src={require('../assets/image/logo.png')} alt="logo" />
						</Link>
					</div>
					<div className="pms-nav-list">
						<div className="pms-nav-list-container">
							{this.navList()}
						</div>
						<div className="pms-user">
							<div className="pms-select-language">
								<select ref="selectLaugage" name="" id="" onChange={(e) => this.changeLanguage(e)}>
									<option value="chinese">CHINESE</option>
									<option value="english">ENGLISH</option>
								</select>
								<div className="login-button"><a target="blank" href="http://order.pms.com.cn">{LoginView[language]}</a></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./public/components/nav.js